import { useFilterSearchParams } from 'pages/Shipments/Containers/utilities';
import { RadioGroup } from 'components/tailwind-ui/RadioGroup';
import * as React from 'react';

type DemurrageValue = 'due' | 'notDue';

const OPTIONS: { label: string; value: DemurrageValue }[] = [
  { label: 'Demurrage due', value: 'due' },
  { label: 'No demurrage due', value: 'notDue' },
];

interface FilterState {
  demurrage: DemurrageValue | null;
}

export const Demurrage: React.FC = () => {
  const { searchParams, setSearchParams } = useFilterSearchParams(true);

  const filterStates: FilterState = React.useMemo(() => {
    let demurrage: FilterState['demurrage'] = null;

    const { demurrageDue } = searchParams;
    if (demurrageDue === true) {
      demurrage = 'due';
    } else if (demurrageDue === false) {
      demurrage = 'notDue';
    }

    return {
      demurrage,
    };
  }, [searchParams]);

  const handleChange = (value: DemurrageValue) => {
    setSearchParams({ demurrageDue: value === 'due' });
  };

  const clearFilter = () => {
    setSearchParams({ demurrageDue: null });
  };

  return (
    <RadioGroup
      label="Demurrage"
      options={OPTIONS}
      onChange={handleChange}
      onClear={clearFilter}
      filterState={filterStates.demurrage}
    />
  );
};
Demurrage.displayName = 'Filters.More.Pickup.Demurrage';
